import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KcsContentSearchComponent } from './kcs-content-search/kcs-content-search.component';
import { KcsPrivacyPolicySearchComponent } from './kcs-privacy-policy-search/kcs-privacy-policy-search.component';
import { KeywordContextualSearchModule } from './keyword-contextual-search.module';
import { KcsTitleSearchComponent } from './kcs-title-search/kcs-title-search.component';

const appRoutes: Routes = [
  {
    path: 'privacy-policy',
    component: KcsPrivacyPolicySearchComponent
  },
  {
    path: 'content',
    component: KcsContentSearchComponent
  },
  {
    path: 'title',
    component: KcsTitleSearchComponent
  },
  {
    path: '',
    redirectTo: 'content',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    CommonModule,
    KeywordContextualSearchModule,
    RouterModule.forChild(appRoutes)
  ]
})
export class KeywordContextualSearchRoutingModule {}
